import { Organization, RealmA6bEnum, Role } from '@goldcast/api/backend';

import { State, GetIsPermissionAllowedParams, PermissionType } from './types';
const rolesRealm: Array<RealmA6bEnum> = ['studio_app', 'event_app', 'content_lab'];

const getters = {
  getIsPermissionAllowed:
    (state: State, getters, rootState, rootGetters) =>
    ({ permissionType, hasBasicWorkspacePermission = true }: GetIsPermissionAllowedParams) => {
      const isPermissionsEnabled: boolean = rootGetters['orgPricingConfig/getIsPermissionsEnabled'];

      if (isPermissionsEnabled) {
        const permissionList = state.permissionConfig?.permission_list ?? [];

        // If permission list contains *:* then allow all permissions
        if (permissionList.includes('*:*')) {
          return true;
        }

        // Check if all required permissions are included in the permission list
        return permissionType.every(permission => {
          const [resourceType, action] = permission.split(':');
          const resourceWildcardPermission = `${resourceType}:*` as PermissionType;
          const actionWildcardPermission = `*:${action}` as PermissionType;

          return (
            permissionList.includes(permission) ||
            permissionList.includes(resourceWildcardPermission) ||
            permissionList.includes(actionWildcardPermission)
          );
        });
      }

      const currentOrg: Organization = rootGetters['org/getCurrentOrg'];

      if (currentOrg?.is_workspace_enabled) {
        return hasBasicWorkspacePermission;
      }

      return true;
    },
  getAllRoles: (state: State) => {
    let roles: Array<Role> = [];
    rolesRealm.forEach(realm => {
      roles = [...roles, ...(state.rolesByRealm?.[realm] ?? [])];
    });

    return roles;
  }
};

export default getters;
